module.exports = __webpack_public_path__ + "img/BobbyS.dd5e89e1.jpg";